import React, {useState} from "react";
import {useTranslation} from "react-i18next";

import {CircularProgress} from "@material-ui/core";
import {useSelector} from "react-redux";
import {loadParameter} from "../../../redux_slices/contextSlice";

const UserBehavior = () => {
    const {t} = useTranslation();
    const [isLoading, setIsLoading] = useState(true);

    const embededAnalytics = useSelector(state => loadParameter(state, "embededAnalytics"));

    return (
        <div className="col-12 col-md-9 user_behavior">
            <div className="card card-custom gutter-b shadow">
                <div className="card-header flex-wrap pt-6 pb-0 border-bottom border-gray">
                    <div className="card-title">{t("ADMINPANEL.MENU.USER_BEHAVIOR")}</div>
                </div>
                <div className="card-body">
                    {embededAnalytics && isLoading ? (
                        <div
                            className="d-flex justify-content-center align-items-center position-absolute top-0 left-0 w-100 h-100">
                            <CircularProgress/>
                        </div>
                    ) : null}
                    {embededAnalytics ?(
                        <div className={`iframe_container z-index-1`}>
                            <iframe
                                src={embededAnalytics}
                                frameBorder="0"
                                allowFullScreen
                                onLoad={() => setIsLoading(false)}
                            />
                        </div>
                    ): <div className={`alert alert-warning`}>{t("ADMINPANEL.METRICS.EMBEDED.UNDEFINED")}</div>}
                </div>
            </div>
        </div>
    );
};

export default UserBehavior;
